import DeleteAccountModal from './DeleteAccountModal'

export default DeleteAccountModal



// WEBPACK FOOTER //
// ./src/components/DeleteAccountModal/index.js